(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quiet-atlas-cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.QuietAtlasCartDrawer) {
    const rootPath = window.Shopify?.routes?.root || '/';

    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format(cents / 100);
      } catch (error) {
        return `${(cents / 100).toFixed(2)} ${currency}`;
      }
    };

    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const syncCounts = (count) => {
      document.querySelectorAll('[data-qa-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === 0;
      });
    };

    const buildItem = (item, currency) => {
      const article = element('article', 'qa-cart-item');
      if (item.image) {
        const image = element('img', 'qa-cart-item__image');
        image.src = item.image;
        image.alt = item.featured_image?.alt || item.product_title;
        image.width = 192;
        image.height = 240;
        image.loading = 'lazy';
        article.append(image);
      } else {
        article.append(element('div', 'qa-cart-item__image'));
      }

      const copy = element('div', 'qa-cart-item__copy');
      copy.append(element('h3', 'qa-cart-item__title', item.product_title));
      if (item.variant_title && item.variant_title !== 'Default Title') {
        copy.append(element('p', 'qa-cart-item__variant', item.variant_title));
      }
      copy.append(element('p', 'qa-cart-item__price', formatMoney(item.final_line_price, currency)));

      const actions = element('div', 'qa-cart-item__actions');
      const quantity = element('div', 'qa-cart-item__quantity');
      const decrease = element('button', '', '−');
      decrease.type = 'button';
      decrease.dataset.qaCartChange = item.key;
      decrease.dataset.quantity = Math.max(0, item.quantity - 1);
      decrease.setAttribute('aria-label', `Decrease quantity of ${item.product_title}`);
      const count = element('span', '', item.quantity);
      count.setAttribute('aria-label', `Quantity ${item.quantity}`);
      const increase = element('button', '', '+');
      increase.type = 'button';
      increase.dataset.qaCartChange = item.key;
      increase.dataset.quantity = item.quantity + 1;
      increase.setAttribute('aria-label', `Increase quantity of ${item.product_title}`);
      quantity.append(decrease, count, increase);

      const remove = element('button', 'qa-cart-item__remove', 'Remove');
      remove.type = 'button';
      remove.dataset.qaCartChange = item.key;
      remove.dataset.quantity = 0;
      remove.setAttribute('aria-label', `Remove ${item.product_title} from cart`);
      actions.append(quantity, remove);
      copy.append(actions);
      article.append(copy);
      return article;
    };

    const render = (drawer, cart) => {
      const items = drawer.querySelector('[data-qa-cart-items]');
      const empty = drawer.querySelector('[data-qa-cart-empty]');
      const footer = drawer.querySelector('[data-qa-cart-footer]');
      const total = drawer.querySelector('[data-qa-cart-total]');
      const currency = drawer.dataset.currency || cart.currency || 'USD';
      items.replaceChildren();
      cart.items.forEach((item) => items.append(buildItem(item, currency)));
      const isEmpty = cart.item_count === 0;
      empty.hidden = !isEmpty;
      footer.hidden = isEmpty;
      total.textContent = formatMoney(cart.total_price, currency);
      syncCounts(cart.item_count);
      drawer.setAttribute('aria-busy', 'false');
    };

    const fetchCart = async () => {
      const response = await fetch(`${rootPath}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart could not be loaded.');
      return response.json();
    };

    const open = async (drawer) => {
      drawer.setAttribute('aria-busy', 'true');
      if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
      document.documentElement.classList.add('qa-cart-is-open');
      try {
        render(drawer, await fetchCart());
      } catch (error) {
        drawer.querySelector('[data-qa-cart-message]').textContent = error.message;
        drawer.setAttribute('aria-busy', 'false');
      }
    };

    const close = (drawer) => {
      if (drawer.open) drawer.close();
      document.documentElement.classList.remove('qa-cart-is-open');
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-qa-cart-form] form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      const wrapper = form.closest('[data-qa-cart-form]');
      const drawer = document.querySelector(wrapper.dataset.qaCartDrawer);
      const button = form.querySelector('[name="add"]');
      const message = drawer.querySelector('[data-qa-cart-message]');
      const originalLabel = button?.textContent;
      message.textContent = '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.loadingLabel || 'Adding…';
      }
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'This item could not be added.');
        if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
        document.documentElement.classList.add('qa-cart-is-open');
        render(drawer, await fetchCart());
        message.textContent = 'Added to your cart.';
      } catch (error) {
        message.textContent = error.message;
        if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
        document.documentElement.classList.add('qa-cart-is-open');
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
        }
      }
    });

    document.addEventListener('click', async (event) => {
      const openButton = event.target.closest('[data-qa-cart-open]');
      if (openButton) {
        const drawer = document.getElementById(`qa-cart-drawer-${openButton.dataset.qaCartOpen}`);
        if (drawer) await open(drawer);
        return;
      }

      const closeButton = event.target.closest('[data-qa-cart-close]');
      if (closeButton) {
        const drawer = closeButton.closest('[data-qa-cart-drawer]');
        if (drawer) close(drawer);
        return;
      }

      const changeButton = event.target.closest('[data-qa-cart-change]');
      if (changeButton) {
        const drawer = changeButton.closest('[data-qa-cart-drawer]');
        drawer.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${rootPath}cart/change.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: changeButton.dataset.qaCartChange,
              quantity: Number(changeButton.dataset.quantity)
            })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || 'The cart could not be updated.');
          render(drawer, payload);
        } catch (error) {
          drawer.querySelector('[data-qa-cart-message]').textContent = error.message;
          drawer.setAttribute('aria-busy', 'false');
        }
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('[data-qa-cart-drawer]')) close(event.target);
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches('[data-qa-cart-drawer]')) {
        document.documentElement.classList.remove('qa-cart-is-open');
      }
    }, true);

    window.QuietAtlasCartDrawer = { open, close, render };
  }
  } catch(e) { console.error(e); }
})();

})();
